<template>
  <v-col :cols="block.cols" :xs="block.colsxs" :sm="block.colssm" :md="block.colsmd" :lg="block.colslg" :xl="block.colsxl" :offset="block.offset">
    <v-select
      :value="form"

      filled
      :dense="block.dense"
      :label="block.label"

      :items="block.items"
      hide-details="auto"
      :class="block.inputClass"
      placeholder=" "
      @input="$emit('update:form', $event)"
    />
  </v-col>
</template>

<script>
export default {
   name: 'SelectBox',
   model: {
      prop: 'form',
      event: 'update:form'
   },

   props: {
      block: {
         type: Object,
         required: true,
      },
      form: {
         type: Object,
         required: true,
      },
   },
}
</script>
